import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../css/PaymentSuccess.css';

const PaymentSuccess = () => {
  const location = useLocation();
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Try to get payment details from URL query parameter first
    const queryParams = new URLSearchParams(location.search);
    const detailsParam = queryParams.get('details');

    if (detailsParam) {
      try {
        const details = JSON.parse(decodeURIComponent(detailsParam));
        setPaymentDetails(details);
        setLoading(false);
        return;
      } catch (err) {
        console.error('Failed to parse payment details from URL:', err);
      }
    }

    // If not in URL, try to get from session storage
    try {
      const storedDetails = window.sessionStorage.getItem('paymentDetails');
      if (storedDetails) {
        setPaymentDetails(JSON.parse(storedDetails));
      }
    } catch (err) {
      console.error('Failed to parse payment details from session storage:', err);
    } finally {
      setLoading(false);
    }
  }, [location]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="payment-success-page loading">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Loading payment details...</p>
      </div>
    );
  }

  if (!paymentDetails) {
    return (
      <section className="payment-success-section">
        <div className="container">
          <div className="error-content">
            <div className="error-icon">
              <i className="fa fa-exclamation-circle"></i>
            </div>
            <h4>Payment Information Unavailable</h4>
            <p>We couldn't retrieve your payment information.</p>
            <Link to="/" className="btn btn-outline">Return Home</Link>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="payment-success-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 mb-3 mb-md-0">
            <div className="position-stick-top">
              <h4>Payment Successful</h4>
              <div className="success-summary mb-4">
                <div className="success-icon">
                  <i className="fa fa-check-circle"></i>
                </div>
                <p className="success-message">
                  Thank you for your payment, <span className="user-name">{paymentDetails.firstName} {paymentDetails.lastName}</span>! Your transaction has been completed successfully.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="content">
              <div className="instruction-card">
                <div className="card-header">
                  <i className="fa fa-info-circle"></i>
                  <h5>Payment Details</h5>
                </div>
                <div className="card-body">
                  <div className="payment-details">
                    <div className="detail-item">
                      <span className="label">Program</span>
                      <span className="value">{paymentDetails.programName}</span>
                    </div>
                    <div className="detail-item">
                      <span className="label">Amount Paid</span>
                      <span className="value highlight">${Number(paymentDetails.amount).toFixed(2)} CAD</span>
                    </div>
                    <div className="detail-item">
                      <span className="label">Payment Method</span>
                      <span className="value">
                        {paymentDetails.paymentMethod === "paypal"
                          ? "PayPal"
                          : paymentDetails.paymentMethod === "e-transfer"
                            ? "E-Transfer"
                            : paymentDetails.paymentMethod === "inOffice"
                              ? "In Office"
                              : "N/A"}
                      </span>
                    </div>

                    <div className="detail-item">
                      <span className="label">Date</span>
                      <span className="value">{formatDate(paymentDetails.timestamp)}</span>
                    </div>
                  </div>

                  <div className="next-steps">
                    <div className="help-options">
                      <div className="help-item">
                        <i className="fa fa-envelope"></i>
                        <span>Confirmation email sent</span>
                      </div>
                      <div className="help-item">
                        <i className="fa fa-calendar"></i>
                        <span>Our team will contact you shortly</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/" className="btn btn-outline">Return Home</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PaymentSuccess; 